import { toSafeString } from '@shared/utils';

export const BLOCKER_COPY_BY_CODE = Object.freeze({
  needs_desktop: 'Needs desktop to continue',
  retry_available: 'Run failed'
});

export const normalizeThreadBlockerCode = (value) => {
  const normalized = String(value || '')
    .trim()
    .toLowerCase();

  if (!normalized) {
    return null;
  }

  if (normalized === 'needs desktop to continue' || normalized.includes('needs_desktop') || normalized.includes('needs-desktop') || normalized.includes('desktop_required') || normalized.includes('requires_desktop') || normalized.includes('desktop_unavailable') || normalized.includes('needs desktop')) {
    return 'needs_desktop';
  }

  if (normalized === 'run failed, retry available' || normalized.includes('retry_available') || normalized.includes('retry-available') || normalized.includes('run_failed') || normalized.includes('run-failed') || normalized.includes('retry available')) {
    return 'retry_available';
  }

  return null;
};

export const getThreadBlockerMessageFromCode = (blockerCode) => {
  const normalizedBlockerCode = normalizeThreadBlockerCode(blockerCode);

  if (!normalizedBlockerCode) {
    return null;
  }

  return BLOCKER_COPY_BY_CODE[normalizedBlockerCode] || null;
};

export const buildThreadBlockerKey = ({ blockerCode, runId } = {}) => {
  const normalizedBlockerCode = normalizeThreadBlockerCode(blockerCode);

  if (!normalizedBlockerCode) {
    return null;
  }

  return `${normalizedBlockerCode}:${toSafeString(runId)}`;
};
